import React from'react';import OrderDetails from"../providers/OrderDetailsProvider.context";import OrderHistory from"../providers/OrderHistoryProvider.context";/**
 * Returns the value of the order details provider state.
 * @returns {Object}
 */export var useOrderDetails=function useOrderDetails(){return React.useContext(OrderDetails);};/**
 * Returns the value of the order details provider state.
 * @returns {Object}
 */export var useOrderHistory=function useOrderHistory(){return React.useContext(OrderHistory);};